<template>
  <div>
    <Head title="Update Item Asset" />
    <h1 class="mb-8 text-3xl font-bold">
      Inventaris
      <span class="text-indigo-400 font-medium"> / </span>
      <Link class="text-indigo-400 hover:text-indigo-600" href="/item_assets">
        Item Asset
      </Link>
      <span class="text-indigo-400 font-medium"> / </span> {{ props.itemAsset.item_name }}
    </h1>
    <div class="max-w-3xl bg-white rounded-md shadow overflow-hidden">
      <form @submit.prevent="update">
        <div class="flex flex-wrap -mb-8 -mr-6 p-8">
          <div class="pb-8 pr-6 w-full md:w-3/5">
            <label class="form-label">Pilih Item:</label>
            <vSelect
              v-model="form.mst_item_id"
              class="focus:text-indigo-500"
              :class="{ error: form.errors.mst_item_id }"
              placeholder="[Pick Item...]"
              label="name"
              :reduce="(option) => option.id"
              :filterable="false"
              :options="itemOptions"
              :append-to-body="true"
              @search="onSearch" />
            <div v-if="form.errors.mst_item_id" class="form-error whitespace-normal">
              {{ form.errors.mst_item_id }}
            </div>
          </div>
          <text-input
            v-model="form.asset_no"
            :error="form.errors.asset_no"
            class="pb-8 pr-6 w-2/5"
            disabled
            label="No. Inventaris" />
          <text-input
            v-model="form.serial_num"
            :error="form.errors.serial_num"
            class="pb-8 pr-6 w-1/3"
            label="No. Seri" />
          <select-input
            v-model="form.condition"
            :error="form.errors.condition"
            class="pb-8 pr-6 w-1/3"
            label="Kondisi Asset">
            <option value="NEW">
              BARU
            </option>
            <option value="USED">
              BEKAS
            </option>
          </select-input>
          <text-input
            v-model="form.barcode01"
            :error="form.errors.barcode01"
            class="pb-8 pr-6 w-1/3"
            label="ULID (QR ID)"
            disabled />
          <text-input
            :model-value="props.itemAsset.status"
            input-class="font-bold text-center"
            class="pb-8 pr-6 w-1/2 md:w-1/3"
            label="*) Status Asset"
            disabled />
          <select-input
            v-model="form.asset_ownership"
            :error="form.errors.asset_ownership"
            class="pb-8 pr-6 w-full md:w-1/3"
            label="Owner">
            <option value="OFFICE">
              OFFICE
            </option>
            <option value="SHARED">
              SHARED
            </option>
          </select-input>
          <select-input
            v-model="form.project_id"
            :error="form.errors.project_id"
            class="pb-8 pr-6 w-full md:w-1/3"
            label="Sumber Dana (Project)">
            <option
              v-for="project in projects"
              :key="project.id"
              :value="project.id">
              {{ project.title }}
            </option>
          </select-input>
          <text-input
            :model-value="props.itemAsset.employee_name"
            class="pb-8 pr-6 w-1/2"
            label="*) Penanggung Jawab"
            disabled />
          <text-input
            :model-value="props.itemAsset.purchase_location_name"
            class="pb-8 pr-6 w-1/4"
            label="Lokasi Pembelian"
            disabled />
          <text-input
            :model-value="props.itemAsset.item_location_name"
            class="pb-8 pr-6 w-1/4"
            label="*) Lokasi Sekarang"
            disabled />
          <div class="pb-8 pr-6 w-full md:w-1/2">
            <label class="form-label">Harga Beli:</label>
            <number-input v-model="form.purchase_price" :error="form.errors.purchase_price" />
            <div v-if="form.errors.purchase_price" class="form-error whitespace-normal">
              {{ form.errors.purchase_price }}
            </div>
          </div>
          <div class="pb-8 pr-6 w-full md:w-1/3">
            <label class="form-label">Perkiraan Depresiasi Tahunan:</label>
            <number-input
              v-model="form.depreciation_rate"
              :max="0.99"
              :error="form.errors.depreciation_rate" />
            <p class="text-sm text-gray-500">
              *) pecahan desimal, mis. 0,10 = 10% per tahun. Bukan nominal rupiah.
            </p>
            <div v-if="form.errors.depreciation_rate" class="form-error whitespace-normal">
              {{ form.errors.depreciation_rate }}
            </div>
          </div>
          <textarea-input
            v-model="form.desc"
            :error="form.errors.desc"
            label="Deskripsi Asset"
            class="pb-8 pr-6 w-full md:w-1/2" />
          <div class="flex flex-col pb-8 pr-6 w-full md:w-1/2">
            <label>Tanggal Pengadaan:</label>
            <flat-pickr v-model="form.purchase_date" class="mt-2 p-2 w-full text-center border rounded" />
            <div v-if="form.errors.purchase_date" class="form-error">
              {{ form.errors.purchase_date }}
            </div>
          </div>
          <div class="w-full">
            <span class="text-red-500">Untuk inputan yang tidak bisa diedit langsung melalui form update (status, penanggung jawab dan lokasi sekarang), dapat diupdate melalui fitur [MUTASI ASSET].</span>
          </div>
        </div>
        <div class="-mr-6 px-8 py-4 border-t border-gray-100" id="attachments">
          <h3 class="text-xl">
            List berkas pendukung:
          </h3>

          <ul
            v-for="(docfile, idx) in props.itemAsset.files"
            :key="idx"
            class="w-full list-disc">
            <li class="flex gap-2 items-center">
              <span>- </span>
              <a
                :href="docfile.url"
                :class="props.attachmentAccess.download ? 'text-indigo-500 underline' : 'text-red-600'"
                target="_blank"
                :download="docfile.file_name"
                :disable="!props.attachmentAccess.download"> {{ docfile.file_name }}</a> ( {{ docfile.size }} )
              <a
                href=""
                title="Delete attachment file"
                @click.prevent="destroyAttachment(docfile.uuid)">
                <Icon icon="ic:baseline-delete-forever" class="w-6 h-6 text-red-600" />
              </a>
            </li>
          </ul>

          <file-input
            v-model="uploadForm.attachment"
            :error="uploadForm.errors.attachment"
            class="pr-6 py-4 w-full md:w-2/3"
            type="file"
            accept="image/*, application/pdf"
            label="Browse dan upload file dokumen pendukung (Max 10MB)"
            @update:model-value="uploadAttachment"
            v-if="props.attachmentAccess.upload" />
        </div>
        <div class="flex items-center justify-end px-8 py-4 bg-gray-50 border-t border-gray-100">
          <Link
            type="button"
            class="btn-red m-2"
            as="button"
            :href="`/item_assets/${itemAsset.id}/mutasi`">
            Mutasi Asset
          </Link>
          <loading-button
            :loading="form.processing"
            class="btn-indigo"
            type="submit">
            Update Item Asset
          </loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import Layout from '@/Shared/Layout.vue'

export default {
    layout: Layout,
}
</script>

<script setup>
import { Head, Link, useForm, router } from '@inertiajs/vue3'
import { ref, defineProps } from 'vue'
import TextInput from '@/Shared/TextInput.vue'
import SelectInput from '@/Shared/SelectInput.vue'
import TextareaInput from '@/Shared/TextareaInput.vue'
import LoadingButton from '@/Shared/LoadingButton.vue'
import NumberInput from '@/Shared/NumberInput'
import FileInput from '@/Shared/FileInput.vue'
import { Icon } from '@iconify/vue'
import { throttle } from 'lodash'
import vSelect from 'vue-select'
import 'vue-select/dist/vue-select.css'
import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'

const props = defineProps({
    itemAsset: Object,
    projects: Array,
    selectedItemOptions: Object,
    attachmentAccess: Object,
})

const itemOptions = ref([props.selectedItemOptions])
const form = useForm({
    ...props.itemAsset,
})

const uploadForm = useForm({
    attachment: null,
})

const fetchItemOptions = throttle((loading, search) => {
    fetch(`/items?options=1&types=STOCK&search=${escape(search)}`).then((res) => {
        res.json().then((json) => (itemOptions.value = json.items))
        loading(false)
    })
}, 500)

function onSearch (search, loading) {
    if (search.length) {
        loading(true)
        fetchItemOptions(loading, search)
    }
}

const update = () => {
    form.put(`/item_assets/${props.itemAsset.id}`, {
        preserveScroll: true,
    })
}

const uploadAttachment = () => {
    if (!uploadForm.attachment) return
    uploadForm.post(`/item_assets/${props.itemAsset.id}/attachment`, {
        preserveScroll: true,
        onSuccess: () => uploadForm.reset('attachment'),
    })
}

const destroyAttachment = (uuid) => {
    if (confirm('Are you sure you want to delete this attachment file?')) {
        router.delete(`/attachment/${uuid}`)
    }
}
</script>

<style scoped>
.v-select {
  --vs-line-height: 1.85;
}
</style>
